export const calcFoldIndex = (
    tagElList: HTMLDivElement[],
    container: HTMLDivElement,
    addTagEl: HTMLDivElement | null = null
) => {
    if (!tagElList.length || !container) {
        return -1;
    }

    let addTagElWidth = 0;
    if (addTagEl) {
        addTagElWidth = addTagEl.offsetWidth;
    }

    const gap = 8;
    let useableWidth = container.offsetWidth - addTagElWidth - gap;

    // 第一个折叠的元素位置
    let foldStartIndex = tagElList.findIndex((elem: HTMLDivElement) => {
        if (elem.offsetLeft + elem.offsetWidth > useableWidth) {
            return true;
        }
        return false;
    });

    if (foldStartIndex > -1) {
        // FIXME: 更多按钮的宽度写死了
        const moreBtnWidth = 30;
        useableWidth = useableWidth - moreBtnWidth - gap;
        foldStartIndex = tagElList.findIndex((elem: HTMLDivElement) => {
            if (elem.offsetLeft + elem.offsetWidth > useableWidth) {
                return true;
            }
            return false;
        });
    }

    return foldStartIndex;
};
